/* eslint-disable @typescript-eslint/no-unsafe-assignment,
@typescript-eslint/no-unsafe-call,
@typescript-eslint/no-unsafe-return,
@typescript-eslint/restrict-template-expressions */
import { useTranslation } from 'react-i18next';

import { TranslatedCellProps } from './translated-cell.type';

import { templateReasonsRejected } from '@/constants/template';

const TranslatedCell = <SELECTED_KEY,>({
  expectedKeys,
  notationTrace,
  translatedKey,
}: TranslatedCellProps<SELECTED_KEY>) => {
  const { t } = useTranslation();

  const translationPath = () => {
    let valueTranslationPath;

    if (!expectedKeys.includes(translatedKey as string)) {
      valueTranslationPath = translatedKey;
    }

    if (!(translatedKey as string).trim().length) {
      valueTranslationPath = t(
        `${notationTrace}.${templateReasonsRejected.UNKNOWN}`
      );
    }

    if (expectedKeys.includes(translatedKey as string)) {
      valueTranslationPath = t(`${notationTrace}.${translatedKey}`);
    }

    return valueTranslationPath;
  };

  return translationPath();
};

export default TranslatedCell;
